module.exports = __webpack_public_path__ + "static/andy-2cba21f970f8a27dc4b3ddb42ba5993a.jpg";